export default function () {
  const spotifyScript = 'https://open.spotify.com/embed/iframe-api/v1';

  const playerStart = () => {
    const elements = document.querySelectorAll('.azds-post__spotify');
    elements.forEach((element) => {
      const options = {
        uri: element.dataset.src,
        width: '100%',
        height: '160',
      };
      const callback = (EmbedController) => {
        if (window.location.search.substring('autoplay=true')) {
          if (sessionStorage.getItem('preloaderDone')) {
            EmbedController.play();
          } else {
            document.addEventListener('preloaderDone', () => {
              EmbedController.play();
            });
          }
        }
      };
      window.azdsIFrameAPI.createController(element, options, callback);
    });
  };

  if (window.azdsIFrameAPI) {
    playerStart();
  } else {
    const script = document.createElement('script');
    script.src = spotifyScript;
    document.head.appendChild(script);

    window.onSpotifyIframeApiReady = (IFrameAPI) => {
      window.azdsIFrameAPI = IFrameAPI;
      playerStart();
    };
  }
}
